import MenuLesson, { MenuLessonProps } from './MenuLesson';

export type { MenuLessonProps };
export default MenuLesson;
